import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CONTENT_IMAGES } from './data';
export function ContentCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + CONTENT_IMAGES.length) % CONTENT_IMAGES.length);
  };
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-21">
      <div className="text-center mb-10" data-id="element-22">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white" data-id="element-23">
          Qué te vas a <span className="text-amber-400" data-id="element-24">encontrar dentro</span>
        </h2>
      </div>

      <div className="relative bg-zinc-900/50 border border-zinc-800 rounded-2xl p-3 sm:p-4 shadow-2xl" data-id="element-25">
        {/* Image frame */}
        <div className="relative aspect-[3/4] sm:aspect-[4/3] overflow-hidden rounded-xl bg-zinc-950" data-id="element-26">
          <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-27">
            <motion.img key={index} src={CONTENT_IMAGES[index]} alt={`Vista previa del contenido ${index + 1}`} custom={direction} initial={{
            opacity: 0,
            x: direction > 0 ? 60 : -60
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction > 0 ? -60 : 60
          }} transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} onClick={scrollToCompra} className="absolute inset-0 w-full h-full object-contain cursor-pointer" data-id="element-28" />
          </AnimatePresence>

          {/* Arrows */}
          <button aria-label="Anterior" onClick={() => paginate(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 text-white backdrop-blur-sm transition-colors" data-id="element-29">
            <ChevronLeft className="w-6 h-6" data-id="element-30" />
          </button>
          <button aria-label="Siguiente" onClick={() => paginate(1)} className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 text-white backdrop-blur-sm transition-colors" data-id="element-31">
            <ChevronRight className="w-6 h-6" data-id="element-32" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-33">
          {CONTENT_IMAGES.map((_, i) => <button key={i} aria-label={`Ir a la imagen ${i + 1}`} onClick={() => {
          setDirection(i > index ? 1 : -1);
          setIndex(i);
        }} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-amber-400' : 'w-2 bg-zinc-600 hover:bg-zinc-500'}`} data-id="element-34" />)}
        </div>
      </div>

      <p className="text-center text-zinc-500 text-sm mt-4" data-id="element-35">
        {index + 1} / {CONTENT_IMAGES.length} · Vistas reales del material
      </p>
    </section>;
}